import { render, staticRenderFns } from "./OpenText.vue?vue&type=template&id=13863a75&scoped=true"
import script from "./OpenText.vue?vue&type=script&lang=js"
export * from "./OpenText.vue?vue&type=script&lang=js"
import style0 from "./OpenText.vue?vue&type=style&index=0&id=13863a75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13863a75",
  null
  
)

export default component.exports